module.exports = __webpack_public_path__ + "img/arrowUp.ba430f0b.svg";